import { NgModule } from '@angular/core';
import { CallbackPipe } from './callback.pipe';

@NgModule({
declarations: [CallbackPipe],
imports: [],
exports: [CallbackPipe],
})

export class PipesModule {}